/* TODO: t() */
import React from 'react';
import { View, StyleSheet } from 'react-native';
import Text from './Text';
import { themeColors } from './Constants';
import { Hoverable } from '.';

type Props = {
  children: React.ReactNode;
  containerStyle?: StyleSet;
  style?: StyleSet;
  title: string;
};

function Tooltip(props: Props) {
  let { children, containerStyle, style, title } = props;
  return (
    <Hoverable
      render={(isHovered, eventHandlers) => (
        <View {...eventHandlers}>
          {children}
          {isHovered && (
            <View style={[styles.tagInfotip, containerStyle]}>
              <View style={styles.triangleBorder}>
                <View style={styles.triangle} />
              </View>
              <Text style={[styles.textCenter, style]} type="label">
                {title}
              </Text>
            </View>
          )}
        </View>
      )}
    />
  );
}

const styles = StyleSheet.create({
  tagInfotip: {
    borderRadius: 2,
    justifyContent: 'center',
    position: 'absolute',
    paddingHorizontal: 5,
    bottom: 39,
    right: 16,
    zIndex: 5,
    backgroundColor: themeColors.white,
    borderColor: themeColors.borderGrey,
    borderWidth: StyleSheet.hairlineWidth,
  },
  textCenter: {
    textAlign: 'center',
  },
  triangle: {
    position: 'absolute',
    bottom: 1,
    right: -5,
    width: 0,
    height: 0,
    zIndex: 5,
    borderColor: 'transparent',
    borderLeftWidth: 5,
    borderTopWidth: 6,
    borderBottomWidth: 0,
    borderRightWidth: 5,
    borderTopColor: themeColors.white,
  },
  triangleBorder: {
    position: 'absolute',
    bottom: -6,
    right: -1,
    width: 0,
    height: 0,
    zIndex: 5,
    borderColor: 'transparent',
    borderLeftWidth: 6,
    borderTopWidth: 6,
    borderBottomWidth: 0,
    borderRightWidth: 6,
    borderTopColor: themeColors.borderGrey,
  },
});

export default Tooltip;
